import { graphql } from '@e-socna/data-layer';

export const MissionReportPage_ReportVersions_QueryDocument = graphql(`
  query MissionReportPage_ReportVersions_Query($originalId: Id!) {
    findAllEditableVersionsForOneOriginalId: findAllReportVersionsForOneOriginalId(
      originalId: $originalId
    ) {
      _id
      createdAt
      creatorId
      automaticMemo
      internalMemo
      memo
      version {
        _id
        creatorId
        updaterId
        createdAt
        updatedAt
        contentUpdatedAt

        title
        templateId
        typeId

        printing {
          printSettings {
            _id
            addHeaders
            addFooters
            printStyleId
          }
          pdfPrintsIncrement
        }

        code
        codingConfig {
          _id
          kind
          strategyId
          ... on CodingConfigManual {
            code
          }
        }

        virtualRoot {
          _id
          template {
            _id
            type
          }
          contentOriginId
          isVirtual
          hasPagebreakBefore
          hasPagebreakAfter
          title
          content
          orientation
          paperFormat
          isInsertionPoint
          customLayouts {
            _id
            sectionId
            orientation
            paperFormat
            hasPagebreakAfter
            hasPagebreakBefore
          }
          displayCondition {
            mode
            resolverId
            value
          }

          subSections {
            _id
            template {
              _id
              type
            }
            contentOriginId
            isVirtual
            hasPagebreakBefore
            hasPagebreakAfter
            title
            content
            orientation
            paperFormat
            isInsertionPoint
            customLayouts {
              _id
              sectionId
              orientation
              paperFormat
              hasPagebreakAfter
              hasPagebreakBefore
            }
            displayCondition {
              mode
              resolverId
              value
            }

            subSections {
              _id
              template {
                _id
                type
              }
              contentOriginId
              isVirtual
              hasPagebreakBefore
              hasPagebreakAfter
              title
              content
              orientation
              paperFormat
              isInsertionPoint
              customLayouts {
                _id
                sectionId
                orientation
                paperFormat
                hasPagebreakAfter
                hasPagebreakBefore
              }
              displayCondition {
                mode
                resolverId
                value
              }

              subSections {
                _id
                template {
                  _id
                  type
                }
                contentOriginId
                isVirtual
                hasPagebreakBefore
                hasPagebreakAfter
                title
                content
                orientation
                paperFormat
                isInsertionPoint
                customLayouts {
                  _id
                  sectionId
                  orientation
                  paperFormat
                  hasPagebreakAfter
                  hasPagebreakBefore
                }
                displayCondition {
                  mode
                  resolverId
                  value
                }

                subSections {
                  _id
                  template {
                    _id
                    type
                  }
                  contentOriginId
                  isVirtual
                  hasPagebreakBefore
                  hasPagebreakAfter
                  title
                  content
                  orientation
                  paperFormat
                  isInsertionPoint
                  customLayouts {
                    _id
                    sectionId
                    orientation
                    paperFormat
                    hasPagebreakAfter
                    hasPagebreakBefore
                  }
                  displayCondition {
                    mode
                    resolverId
                    value
                  }

                  subSections {
                    _id
                    template {
                      _id
                      type
                    }
                    contentOriginId
                    isVirtual
                    hasPagebreakBefore
                    hasPagebreakAfter
                    title
                    content
                    orientation
                    paperFormat
                    isInsertionPoint
                    customLayouts {
                      _id
                      sectionId
                      orientation
                      paperFormat
                      hasPagebreakAfter
                      hasPagebreakBefore
                    }
                    displayCondition {
                      mode
                      resolverId
                      value
                    }

                    subSections {
                      _id
                      template {
                        _id
                        type
                      }
                      contentOriginId
                      isVirtual
                      hasPagebreakBefore
                      hasPagebreakAfter
                      title
                      content
                      orientation
                      paperFormat
                      isInsertionPoint
                      customLayouts {
                        _id
                        sectionId
                        orientation
                        paperFormat
                        hasPagebreakAfter
                        hasPagebreakBefore
                      }
                      displayCondition {
                        mode
                        resolverId
                        value
                      }

                      subSections {
                        _id
                        template {
                          _id
                          type
                        }
                        contentOriginId
                        isVirtual
                        hasPagebreakBefore
                        hasPagebreakAfter
                        title
                        content
                        orientation
                        paperFormat
                        isInsertionPoint
                        customLayouts {
                          _id
                          sectionId
                          orientation
                          paperFormat
                          hasPagebreakAfter
                          hasPagebreakBefore
                        }
                        displayCondition {
                          mode
                          resolverId
                          value
                        }

                        subSections {
                          _id
                          template {
                            _id
                            type
                          }
                          contentOriginId
                          isVirtual
                          hasPagebreakBefore
                          hasPagebreakAfter
                          title
                          content
                          orientation
                          paperFormat
                          isInsertionPoint
                          customLayouts {
                            _id
                            sectionId
                            orientation
                            paperFormat
                            hasPagebreakAfter
                            hasPagebreakBefore
                          }
                          displayCondition {
                            mode
                            resolverId
                            value
                          }

                          subSections {
                            _id
                            template {
                              _id
                              type
                            }
                            contentOriginId
                            isVirtual
                            hasPagebreakBefore
                            hasPagebreakAfter
                            title
                            content
                            orientation
                            paperFormat
                            isInsertionPoint
                            customLayouts {
                              _id
                              sectionId
                              orientation
                              paperFormat
                              hasPagebreakAfter
                              hasPagebreakBefore
                            }
                            displayCondition {
                              mode
                              resolverId
                              value
                            }

                            subSections {
                              _id
                              template {
                                _id
                                type
                              }
                              contentOriginId
                              isVirtual
                              hasPagebreakBefore
                              hasPagebreakAfter
                              title
                              content
                              orientation
                              paperFormat
                              isInsertionPoint
                              customLayouts {
                                _id
                                sectionId
                                orientation
                                paperFormat
                                hasPagebreakAfter
                                hasPagebreakBefore
                              }
                              displayCondition {
                                mode
                                resolverId
                                value
                              }

                              subSections {
                                _id
                                template {
                                  _id
                                  type
                                }
                                contentOriginId
                                isVirtual
                                hasPagebreakBefore
                                hasPagebreakAfter
                                title
                                content
                                orientation
                                paperFormat
                                isInsertionPoint
                                customLayouts {
                                  _id
                                  sectionId
                                  orientation
                                  paperFormat
                                  hasPagebreakAfter
                                  hasPagebreakBefore
                                }
                                displayCondition {
                                  mode
                                  resolverId
                                  value
                                }

                                subSections {
                                  _id
                                  template {
                                    _id
                                    type
                                  }
                                  contentOriginId
                                  isVirtual
                                  hasPagebreakBefore
                                  hasPagebreakAfter
                                  title
                                  content
                                  orientation
                                  paperFormat
                                  isInsertionPoint
                                  customLayouts {
                                    _id
                                    sectionId
                                    orientation
                                    paperFormat
                                    hasPagebreakAfter
                                    hasPagebreakBefore
                                  }
                                  displayCondition {
                                    mode
                                    resolverId
                                    value
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);
